module.exports = __webpack_public_path__ + "static/optimo-zaleta-5-83bd4ebd135e51626d81439f12f930f1.png";